export function getFIOPartsFromFIOString(str?: string) {
  const words = str?.split(" ");

  if (!words || words.length === 0) {
    return { surname: "", name: "", patronymic: "" };
  }
  if (words.length === 1) {
    return { surname: words[0], name: "", patronymic: "" };
  }

  if (words.length === 2) {
    return { surname: words[0], name: words[1], patronymic: "" };
  }

  return {
    surname: words[0],
    name: words[1],
    patronymic: words.slice(2).join(" "),
  };
}
